import React from 'react';
import { useNavigate, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Dropdown, Icon } from 'semantic-ui-react';
import styled from 'styled-components';

import { useAppSelector } from '@/store';
import { authStore } from '@/store/auth';
import { enabledFeatureFlagsApi } from '@/services/api';

import { pages } from '@/settings/pages';
import { auth } from '@/constants';

export const LoginMenu: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const gloplaId = useAppSelector(authStore.selectors.gloplaIdSelector);

  const linkTo =
    (to: string, withLocation = false) =>
    () => {
      if (withLocation) {
        navigate(to, { state: { from: location } });
      } else {
        navigate(to);
      }
    };
  const openOrganizationSelectPage = async () => {
    const areOrganizationsSelectTransferred =
      await enabledFeatureFlagsApi.getDetail('organization_select_transfer');
    if (areOrganizationsSelectTransferred.enabled) {
      linkTo(pages.organizations)();
    } else {
      window.location.href = auth.Url.signinUri;
    }
  };

  return (
    <Styled>
      {gloplaId && (
        <Dropdown
          className="dropdown-menu"
          data-test="dropdown-menu"
          item={true}
          text={t('ui.menus.menu')}
        >
          <Dropdown.Menu className="login-menu-dropdown">
            {/* Home */}
            <Dropdown.Item data-test="home" onClick={linkTo(pages.top)}>
              {t('pages.home.title')}
            </Dropdown.Item>

            {/* 管理者一覧 */}
            <Dropdown.Item
              data-test="memberships"
              onClick={linkTo(pages.membership.index)}
            >
              {t('pages.membership.index.title')}
            </Dropdown.Item>

            {/* アカウント情報 */}
            <Dropdown.Item
              data-test="account"
              onClick={linkTo(pages.account.index)}
            >
              {t('pages.account.index.title')}
            </Dropdown.Item>

            {/* 所属組織の選択 */}
            <Dropdown.Item onClick={() => openOrganizationSelectPage()}>
              {t('pages.organizations.title')}
            </Dropdown.Item>

            {/* 操作ガイド・よくある質問 */}
            <Dropdown.Item href={t('pages.support.faq.url')} target="_blank">
              {t('pages.support.faq.title')}
              <Icon name="external" className="right floated login-menu-icon" />
            </Dropdown.Item>

            {/* ログアウト */}
            <Dropdown.Item
              data-test="logout-menu"
              onClick={linkTo(pages.signout.index)}
            >
              {t('ui.action.logout')}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      )}
    </Styled>
  );
};

const Styled = styled.div`
  .dropdown.dropdown-menu {
    height: 100%;
  }

  .ui.menu .external-link-icon {
    position: relative;
    left: 0.5em;
  }

  .ui.dropdown.dropdown-menu .menu > .divider {
    margin: 0;
  }

  .ui.dropdown .menu > .header.dropdown-menu-student-management-header {
    color: #999;
    font-weight: normal;
  }

  .dropdown-menu-student-management-item {
    display: inline-block;
    width: 210px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    padding-left: 12px;
  }

  .login-menu-dropdown {
    width: 280px;
  }

  .login-menu-icon {
    color: #24387c;
  }
`;
